export const state = (): CreditCode => ({
  creditCodeValue: null,
  locale: null
})

export const GET_CREDIT_CODE_VALUE = "getCreditCodeValue"
export const GET_CREDIT_CODE_LOCALE = "getCreditCodeLocale"
export const GET_CREDIT_CODE_CURRENCY = "getCreditCodeCurrency"

const getCurrencySymbol = (locale: string | null): string => {
  if (!locale) return "£"

  const normalizedLocale = locale.toLowerCase()

  if (normalizedLocale === 'en-us') {
    return '$'
  } else if (normalizedLocale === 'en-gb') {
    return "£"
  } else {
    return "€"
  }
}

export const getters = {
  [GET_CREDIT_CODE_VALUE]: (state: CreditCode): number | null => state.creditCodeValue,
  [GET_CREDIT_CODE_LOCALE]: (state: CreditCode): string | null => state.locale,
  [GET_CREDIT_CODE_CURRENCY]: (state: CreditCode): string | null => {
    if (state.creditCodeValue === null) {
      return null
    }
    const symbol = getCurrencySymbol(state.locale)
    return `${symbol}`
  }
}

export const _SET_CREDIT_CODE_VALUE = "setCreditCodeValue"
export const _SET_CREDIT_CODE_LOCALE = "setCreditCodeLocale"

export const mutations = {
  [_SET_CREDIT_CODE_VALUE](state: CreditCode, creditCodeValue: number) {
    state.creditCodeValue = creditCodeValue
  },
  [_SET_CREDIT_CODE_LOCALE](state: CreditCode, locale: string) {
    state.locale = locale
  }
}

export const SET_CREDIT_CODE_VALUE = "setCreditCodeValue"
export const SET_CREDIT_CODE_LOCALE = "setCreditCodeLocale"

export const actions = {
  [SET_CREDIT_CODE_VALUE]({ commit }: any, creditCodeValue: number) {
    commit(_SET_CREDIT_CODE_VALUE, creditCodeValue)
  },
  [SET_CREDIT_CODE_LOCALE]({ commit }: any, locale: string) {
    commit(_SET_CREDIT_CODE_LOCALE, locale)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
